<template>
  <div class="pages">
    <div class="cart-main">
      <!-- 标题 -->
      <div ref="cartTitle" class="boxTit" style="margin-top: 16px">{{ $t('购物车') }}</div>
      <!-- 全选、收藏、删除 -->
      <div class="cart-container">
        <div ref="cartHeader" class="cart-header">
          <el-checkbox :indeterminate="isIndeterminate" v-model="selectAll" @change="toggleAllSelection">{{ $t('全选')
            }}</el-checkbox>
          <div class="boxAll-btn">
            <div @click="onCollectList">{{ $t('移入收藏') }}</div>
            <div @click="removeItemList">{{ $t('删除') }}</div>
          </div>
        </div>
        <!-- 购物车列表 -->
        <div class="cart-content">
          <div class="shop-card">
            <div class="shop-products" v-if="cartData.length > 0">
              <div ref="cartProduct" v-for="(item, index) in cartData" :key="index" class="product-item">
                <el-checkbox v-model="item.selected" @change="updateSelections"></el-checkbox>
                <img :src="item.product.cover" class="product-image" @click="gotoDetail(item)" />
                <div class="product-info justify-between flex-direction">
                  <div class="text-14">
                    <div class="product-title">{{ item.product.name }}</div>
                    <div class="text-999" style="margin-top: 4px;" v-if="item.sku_price">{{ item.sku_price.name }}</div>
                  </div>
                  <div class="text-22 text-85674B">
                    <span class="text-14">￥</span>{{ item.snapshot_price }}
                  </div>
                </div>
                <el-input-number v-model="item.num" :min="1" size="mini" class="product-quantity"
                  @change="(value) => handleChange(value, item)"></el-input-number>
                <div class="operate-box">
                  <p @click="onCollect(item)">{{ $t('移入收藏') }}</p>
                  <p @click="removeItem(item)">{{ $t('删除') }}</p>
                </div>
              </div>
            </div>
            <div class="empty-cart flex align-center flex-direction" style="width: 100%;padding: 32px 0;" v-else>
              <img src="../../../static/cart.png" alt="" class="list-box-txt-icon">
              <div class="text-999">{{ $t('空空如也~') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 结算弹窗 -->
    <div ref="cartSettlement" class="settlement-wrap">
      <div class="settlement">
        <div class="boxTit">{{ $t('结算明细') }}</div>
        <div class="cart_img_box">
          <img :src="item.product.cover" alt="" v-for="(item, index) in selectedItems" :key="index" class="cart_img" />
        </div>
        <div class="summary">
          <span>{{ $t('商品总结') }}</span>
          <span>￥{{ totalPrice }}</span>
        </div>
        <div class="summary">
          <span>{{ $t('商品数量') }}</span>
          <span>x{{ totalNum }}</span>
        </div>
        <div class="summary" style="margin-top: 32px">
          <span>{{ $t('合计') }}</span>
          <span>￥{{ totalPrice }}</span>
        </div>
        <div class="close_btn pointer" @click="checkout">{{ $t('结算') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserCenterTemp from "@/components/UserCenterTemp";
  import SummaryBar from "@/components/SummaryBar";
  import inputProducts from "../../../static/products.js";
  import ShortcutBar from "@/components/ShortcutBar";
  import rightSuspension from "@/components/rightSuspension.vue";
  import { cartList, addCart, cartGoCollect, cartRemove } from '@/api/user';

  export default {
    name: "ShoppingCart",
    components: {
      "user-center-temp": UserCenterTemp,
      "summary-bar": SummaryBar,
      "shortcut-bar": ShortcutBar,
      rightSuspension,
    },
    data() {
      return {
        selectAll: false,//全选
        isIndeterminate: false,//选择了一部分
        cartData: [],//购物车列表
        selectedItems: [],//选中的商品
        totalPrice: 0,//商品总额
        totalNum: 0,//商品总数
        // 购物车页面入场动画实例，用于组件销毁时释放动画资源
        cartEntranceAnimation: null,
      };
    },
    computed: {
      // totalPrice() {
      //   return this.selectedItems.reduce(
      //     (sum, product) => sum + product.price * product.quantity,
      //     0
      //   );
      // },
    },
    mounted() {
      this.onCartList()
    },
    beforeDestroy() {
      if (this.cartEntranceAnimation) {
        this.cartEntranceAnimation.kill()
      }
    },
    methods: {
      /** 播放购物车页面的入场动效 */
      playCartEntranceAnimation() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return
        }
        if (this.cartEntranceAnimation) {
          this.cartEntranceAnimation.kill()
        }
        const targets = [this.$refs.cartTitle, this.$refs.cartHeader]
          .concat(this.$refs.cartProduct || [])
          .concat([this.$refs.cartSettlement])
          .filter(Boolean)
        this.cartEntranceAnimation = this.$gsap.from(targets, {
          y: 16,
          opacity: 0,
          duration: 0.45,
          stagger: 0.08,
          ease: 'power2.out',
        })
      },
      /**商品选中的信息 */
      pitchMessage() {
        let list = this.cartData
        let selectedItems = []
        let totalPrice = 0
        let totalNum = 0

        list.forEach(item => {
          if (item.selected) {
            totalNum += Number(item.num)
            totalPrice += Number(item.snapshot_price) * Number(item.num)
            selectedItems.push(item)
          }
        })

        this.selectedItems = selectedItems
        this.totalPrice = totalPrice.toFixed(2);
        this.totalNum = totalNum
      },
      /**商品详情 */
      gotoDetail(e) {
        this.$router.push({ name: 'ProductDetails', params: { id: e.product_id } })
      },
      /**购物车批量移入收藏 */
      onCollectList() {
        let list = this.cartData
        let ids = []
        list.forEach(e => {
          if (e.selected) {
            ids.push(e.id)
          }
        })

        if (!ids.length) {
          this.$message.warning(this.$t('请选择移入商品'));
          return
        }

        let data = {
          id: ids.join(',')
        }

        cartGoCollect(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('移入成功'));
            this.onCartList()
          } else {
            this.$message.warning(res.msg);
          }
        })
      },
      /**购物车移入收藏 */
      onCollect(e) {
        let data = {
          id: e.id
        }
        cartGoCollect(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('移入成功'));
            this.onCartList()
          } else {
            this.$message.warning(res.msg);
          }
        })
      },
      /**修改商品信息 */
      handleChange(value, e) {
        let data = {
          product_id: e.product_id,
          sku_price_id: e.sku_price_id,
          type: 'cover',
          num: value,
          id: e.id
        }

        addCart(data).then(res => {
          if (res.code != 1) {
            this.$message.warning(res.msg);
          } else {
            this.pitchMessage()
          }
        })
      },
      /**购物车列表 */
      onCartList() {
        cartList().then(res => {
          this.cartData = res.data
          this.$nextTick(() => {
            this.playCartEntranceAnimation()
          })
        })
      },
      // 商品全选
      toggleAllSelection(val) {
        let list = this.cartData

        list.forEach(item => {
          item.selected = val
        })
        this.pitchMessage()
        this.isIndeterminate = false;
      },
      /**商品单选 */
      updateSelections() {
        let list = []

        this.cartData.flatMap((shop) => {
          if (shop.selected) {
            list.push(shop)
          }
        });

        this.pitchMessage()

        if (list.length > 0) {
          this.isIndeterminate = true
          if (this.cartData.length == list.length) {
            this.selectAll = true
            this.isIndeterminate = false
          }
        } else {
          this.selectAll = false
          this.isIndeterminate = false
        }
      },
      /**购物车删除 */
      removeItemList() {
        let list = this.cartData
        let ids = []
        list.forEach(e => {
          if (e.selected) {
            ids.push(e.id)
          }
        })

        if (!ids.length) {
          this.$message.warning(this.$t('请选择删除商品'));
          return
        }

        let data = {
          id: ids.join(',')
        }

        cartRemove(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('删除成功'));
            this.onCartList()
          } else {
            this.$message.warning(res.msg);
          }
        })
      },
      // 删除购物车
      removeItem(e) {
        let data = {
          id: e.id
        }
        cartRemove(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('删除成功'));
            this.onCartList()
          } else {
            this.$message.warning(res.msg);
          }
        })
      },
      // 结算
      checkout() {
        if (this.selectedItems.length == 0) {
          this.$message.warning(this.$t('请选择结算商品'));
          return
        }
        // console.log("结算的商品：", this.selectedItems);
        // return
        this.$router.push({ name: 'orders', params: { order: encodeURIComponent(JSON.stringify(this.selectedItems)) } })
      },
    },
    created() { },
  };
</script>

<style scoped lang="scss">
  .pages {
    display: flex;
    align-items: stretch;
    width: 100%;
    box-sizing: border-box;
  }

  .cart-main {
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin: 24px 0 24px 16px;
    padding: 24px 16px;
  }

  .settlement-wrap {
    flex: 0 0 320px;
    width: 320px;
    margin: 24px 16px 24px 16px;
    box-sizing: border-box;
  }

  .settlement {
    width: 100%;
    padding: 16px 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    position: sticky;
    top: 16px;

    .summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;
    }

    .close_btn {
      width: 100%;
      height: 48px;
      background: #000000;
      font-size: 16px;
      color: #FFFFFF;
      border-radius: 8px;
      margin-top: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cart_img_box {
      display: flex;
      flex-wrap: wrap;

      .cart_img {
        width: 88px;
        height: 88px;
        border-radius: 8px;
        margin: 0 8px 8px 0;
			object-fit: cover;
			object-position: center;
			display: block;
      }
    }
  }

  /**标题 */
  .boxTit {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }

  .boxAll-btn {
    display: flex;
    margin-left: 24px;

    div {
      width: 80px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #eeeeee;
      text-align: center;
      line-height: 32px;
      margin-right: 8px;
      font-size: 14px;
      cursor: pointer;
    }
  }

  /** 列表*/
  .cart-header {
    display: flex;
    align-items: center;
    padding: 30px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 24px;
  }

  .shop-products {
    .product-item {
      display: flex;
      align-items: center;
      padding: 12px 0;

      .product-image {
        width: 120px;
        height: 120px;
        margin: 0 16px 0 16px;
        border-radius: 8px;
			object-fit: cover;
			object-position: center;
			display: block;
        cursor: pointer;
        flex-shrink: 0;
      }

      .product-info {
        flex: 1;
        min-width: 0;
        height: 120px;
      }

      .product-title {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .product-quantity {
		width: 120px;
        margin-left: auto;
        padding-left: 16px;
        flex-shrink: 0;
		line-height: 30px;

		/deep/ .el-input__inner {
			height: 32px;
			padding: 0 34px;
			line-height: 30px;
			border-color: #EEEEEE;
		}

		/deep/ .el-input__inner:focus {
			border-color: #000000;
		}

		/deep/ .el-input-number__decrease,
		/deep/ .el-input-number__increase {
			width: 30px;
			height: 32px;
			top: 0;
			line-height: 30px;
			box-sizing: border-box;
			background: #FFFFFF;
			color: #333333;
			border: 1px solid #EEEEEE;
		}

		/deep/ .el-input-number__decrease {
			left: 0;
			border-radius: 4px 0 0 4px;
		}

		/deep/ .el-input-number__increase {
			right: 0;
			border-radius: 0 4px 4px 0;
		}

		/deep/ .el-input-number__decrease:hover:not(.is-disabled),
		/deep/ .el-input-number__increase:hover:not(.is-disabled) {
			color: #000000;
			background: #F8F8F8;
		}

		/deep/ .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
		/deep/ .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
			border-color: #000000;
		}
      }

      .product-name {
        width: 300px;
        height: 42px;
      }

      .originalCost {
        color: #999;
        font-size: 18px;
        text-decoration: line-through;
      }

      .price {
        color: #fd3b00;
        font-size: 20px;
        font-weight: bold;
      }

      .operate-box {
        color: #333;
        font-size: 16px;
        text-align: center;
        margin-left: 16px;
        flex-shrink: 0;

        p {
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .pages {
      display: block;
      width: 100%;
      max-width: 100%;
      overflow-x: hidden;
    }

    .cart-main {
      width: 100% !important;
      margin: 0 0 12px !important;
      padding: 12px !important;
      box-sizing: border-box;
    }

    .cart-header {
      padding: 12px 0;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 8px;
    }

    .boxAll-btn {
      margin-left: 0;

      div {
        width: auto;
        padding: 0 12px;
      }
    }

    .product-item {
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 12px 0;
      border-bottom: 1px solid #eee;
    }

    .product-item .product-image {
      width: 72px;
      height: 72px;
      margin: 0 10px 0 8px;
    }

    .product-info {
      width: calc(100% - 118px) !important;
      height: auto !important;
      min-width: 0;
    }

    .product-title {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .product-quantity {
		width: 112px;
      margin: 10px 0 0 28px;
		padding-left: 0;
    }

    .operate-box {
      display: flex;
      align-items: center;
      gap: 16px;
      margin: 10px 0 0 auto;
      font-size: 13px;
      text-align: right;
    }

    .settlement-wrap {
      flex: none;
      width: 100%;
      margin: 0;
    }

    .settlement {
      position: static;
      width: 100%;
      right: auto;
      top: auto;
      margin-top: 0;
      box-sizing: border-box;
    }

    .cart_img_box {
      display: flex;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      .cart_img {
        width: 64px;
        height: 64px;
        flex-shrink: 0;
      }
    }

    .summary[style] {
      margin-top: 16px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/cart/ShoppingCart.vue